var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container action-bar" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 action-bar__actions" },
        [_vm._t("actions")],
        2
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 action-bar__secondary-actions" },
        [
          _vm._t("secondary-actions", function () {
            return [
              _c("span", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.selectedCount) +
                    " " +
                    _vm._s(_vm.$t("mediaGallery.actions.selected")) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("media-gallery-list-actions"),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-12 action-bar__separator" }, [
      _c("hr"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }